import { HttpClient } from '@angular/common/http';

import { AUTH_BASE_URL } from 'app/config';
import { Injectable } from '@angular/core';

const DOCCEUMA_URL = AUTH_BASE_URL + `/doc-ceuma-api/`;

@Injectable()
export class PdfDocInformacoesFinanceirasService {
  constructor(
    private http: HttpClient
  ) { }

  gerarPDF(dadosAluno) {
    /**
     * 4583 - Thiago Augusto - +Code
     * Automatização da carta financeira - DocCeuma
     */
    return this.http.post(DOCCEUMA_URL+`carta/solicitar/`,dadosAluno,{
      responseType: 'blob' as 'json'
    });

    /*
    const doc_definition = Conteudo(dados);

    return this.pdfMakeLoader.generatePdf(doc_definition)
      .then((result: Blob) => {
        this.pdfMakeLoader.downloadFile(result, 'Documento de Informações Financeiras - ' + dados.dadosMatricula.aluno.nome);
        this.notificationsService.success('Sucesso', 'Documento de Informações Financeiras pronto para baixar!');
      })
      .catch(error => {
        console.error(error);
        this.notificationsService.error('Erro', 'Ocorreu um erro na geração do PDF do Documento de Informações Financeiras');
      });
    */
  }

  handleFile(res: any, fileName: string) {
    const file = new Blob([res], {
      type: res.type
    });
    // Verificando se é Internet Explorer
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file);
      return;
    }
    const blob = window.URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = blob;
    link.download = fileName;
    // link.click();
    link.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));
    // firefox
    setTimeout(() => {
      window.URL.revokeObjectURL(blob);
      link.remove();
    }, 100);
  }
}
